import { render, staticRenderFns } from "./GLoading.vue?vue&type=template&id=0043406e&scoped=true&"
import script from "./GLoading.vue?vue&type=script&lang=ts&"
export * from "./GLoading.vue?vue&type=script&lang=ts&"
import style0 from "./GLoading.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./GLoading.vue?vue&type=style&index=1&id=0043406e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0043406e",
  null
  
)

export default component.exports